import { Transform, Type } from 'class-transformer'
import { IsDate, IsOptional, IsString, ValidateNested } from 'class-validator'

export class FacebookEntidadDto {
  @IsString()
  id!: string
}

export class FacebookMessageAttachment {
  @IsString()
  type!: string

  payload!: any
}

export class FacebookMessageDto {
  @IsString()
  mid!: string

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => FacebookMessageAttachment)
  attachments?: FacebookMessageAttachment[]

  @IsOptional()
  @IsString()
  text?: string
}

export class FacebookDataDto {
  @ValidateNested()
  @Type(() => FacebookEntidadDto)
  sender!: FacebookEntidadDto

  @ValidateNested()
  @Type(() => FacebookEntidadDto)
  recipient!: FacebookEntidadDto

  @IsDate()
  @Transform(({ value }) => new Date(value))
  timestamp!: Date

  @ValidateNested()
  @Type(() => FacebookMessageDto)
  message!: FacebookMessageDto
}

export class FacebookEntryDto {
  id!: string
  time!: string
  messaging!: FacebookDataDto[]
}

export class FacebookDto {
  object!: string
  entry!: FacebookEntryDto[]
}
